import { useQuery } from 'react-query';
import {
  getInstagramPost,
  type GetInstagramPostResponse
} from '../../services/instagramPostService';

export function useGetInstagramPost(postId: string) {
  return useQuery<GetInstagramPostResponse, Error, GetInstagramPostResponse>(
    ['instagramPost', postId],
    () => getInstagramPost(postId),
    {
      enabled: !!postId,
      staleTime: 30 * 1000,
      cacheTime: 60 * 1000
    }
  );
}
